import { render } from "./ChangeServiceSelection.vue?vue&type=template&id=7975335e"
import script from "./ChangeServiceSelection.vue?vue&type=script&lang=js"
export * from "./ChangeServiceSelection.vue?vue&type=script&lang=js"

import "./ChangeServiceSelection.vue?vue&type=style&index=0&id=7975335e&lang=scss"

import exportComponent from "/home/ubuntu/jalizan/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__